import { DonutProps } from "@app/shared/metrics/MetricsDonut";
import { QesColors } from "@app/shared/qes-standards/colors";

export const mockDonutData1WithEcd: DonutProps = {
  description: "",
  innerLabelString: "total gaps",
  segments: [
    {
      backgroundColor: QesColors.QesTertiaryGreen2,
      description: "",
      label: "Fillable by single provider",
      numberValue: 449,
    },
    {
      backgroundColor: QesColors.QesTertiaryGreen4,
      description: "",
      label: "Fillable",
      numberValue: 398,
    },
    {
      backgroundColor: QesColors.QesTertiaryYellow2,
      description: "",
      label: "Unfillable, increase in access",
      numberValue: 238,
    },
    {
      backgroundColor: QesColors.QesTertiaryRed2,
      description: "",
      label: "Unfillable, no increase",
      numberValue: 397,
    },
  ],
  title: "Fillability Breakdown",
}

export const mockDonutData1WithoutEcd: DonutProps = {
  description: "",
  innerLabelString: "total gaps",
  segments: [
    {
      backgroundColor: QesColors.QesTertiaryGreen2,
      description: "",
      label: "Fillable by single provider",
      numberValue: 667,
    },
    {
      backgroundColor: QesColors.QesTertiaryYellow2,
      description: "",
      label: "Increase in access by single provider",
      numberValue: 418,
    },
    {
      backgroundColor: QesColors.QesTertiaryRed2,
      description: "",
      label: "Unfillable, no increase",
      numberValue: 397,
    },
  ],
  title: "Fillability Breakdown",
}